package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.background
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent

val HeaderSectionLinearGradientStyleDesktop = CssStyle {
    base {
        Modifier
            .styleModifier {
                background("linear-gradient(" +
                        "${35.deg}," +
                        "${Theme.Primary.rgb} ${0.percent}" + "," +
                        "${Theme.Secondary.rgb} ${100.percent}" // + "," +
//                        "${90.deg}," +
//                        "${Theme.Primary.rgb} ${0.percent}" + "," +
//                        "${Theme.Primary.rgb} ${75.percent}" + "," +
//                        "${Theme.Secondary.rgb} ${100.percent}" // + "," +
                )
//                background("linear-gradient(35deg,rgb(6,0,151) 0%,rgb(130,4,255) 73%,rgb(193,15,255) 100%)")
            }
    }

}

val HeaderSectionLinearGradientStyleMobile = CssStyle {
    base {
        Modifier
            .styleModifier {
                background("linear-gradient(" +
                        "${35.deg}," +
                        "${Theme.Primary.rgb} ${0.percent}" + "," +
                        "${Theme.Secondary.rgb} ${100.percent}" // + "," +
                )
//                background("linear-gradient(35deg,rgb(6,0,151) 0%,rgb(130,4,255) 73%,rgb(193,15,255) 100%)")
            }
    }

}

val FooterSectionRadialGradientStyle = CssStyle {
    base {
        Modifier
            .styleModifier {
                background("radial-gradient(" +
                        "ellipse at bottom, " +
                        "${Theme.Primary.rgb} ${0.percent}" + "," +
                        "${Theme.Primary.rgb} ${40.percent}" + "," +
                        "${Theme.Secondary.rgb} ${120.percent}" // + "," +
                )

//                 background("radial-gradient(ellipse at bottom, rgb(6,0,151) 0%, rgb(130,4,255) 73%, rgb(193,15,255) 100%)")
            }
    }

}
val BannerSectionRadialGradientStyle = CssStyle {
    base {
        Modifier
            .styleModifier {
                background("radial-gradient(" +
                        "ellipse at top left, " +
                        "${Theme.Primary.rgb} ${0.percent}" + "," +
                        "${Theme.Secondary.rgb} ${100.percent}" // + "," +
                )

//                 background("radial-gradient(ellipse at bottom, rgb(6,0,151) 0%, rgb(130,4,255) 73%, rgb(193,15,255) 100%)")
            }
    }

}

val FooterSectionLinearGradientStyle = CssStyle {
    base {
        Modifier
            .styleModifier {
                background("linear-gradient(" +
                        "${35.deg}," +
                        "${Theme.Primary.rgb} ${0.percent}" + "," +
                        "${Theme.Secondary.rgb} ${100.percent}" // + "," +
                )


//                background("linear-gradient(35deg,rgb(6,0,151) 0%,rgb(130,4,255) 73%,rgb(193,15,255) 100%)")
            }
    }

}